import type {
  CompareRequest,
  ComparisonFilters,
  Opportunity,
} from "./types";

export const DEFAULT_FILTERS: ComparisonFilters = {
  buyMarkets: ["cs_market", "avan_market", "aim_market"],
  sellMarkets: ["steam"],
  minBuyPrice: null,
  maxBuyPrice: null,
  minBuyOrders: null,
  maxBuyOrders: null,
  minSellPrice: null,
  maxSellPrice: null,
  minSellOrders: null,
  maxSellOrders: null,
  minProfitPct: null,
  maxProfitPct: null,
  minDailySales: null,
  minMedianDailySales: null,
  minActiveDaysPct: null,
  maxExpectedSaleDays: null,
  minSafeVolumeProfit: null,
  minMedianPrice: null,
  maxMedianPrice: null,
  minAveragePrice: null,
  maxAveragePrice: null,
  priceFilterMode: "current",
  medianWindowDays: 30,
  medianWeighted: true,
  profitableSpreadPct: 10,
  profitSort: "desc",
  hideStickers: false,
  hideNegativeDeals: false,
};

export function toCompareRequest(filters: ComparisonFilters): CompareRequest {
  const usesCurrentPrice = filters.priceFilterMode === "current";
  const usesMedianPrice = filters.priceFilterMode === "median";
  const usesAveragePrice = filters.priceFilterMode === "average";

  return {
    buy_markets: filters.buyMarkets,
    sell_markets: filters.sellMarkets,
    sell_autobuy: false,
    turnover: 0,
    min_trade_amount: null,
    max_trades: null,
    min_profit_pct: filters.minProfitPct,
    max_profit_pct: filters.maxProfitPct,
    min_price: filters.minBuyPrice,
    max_price: filters.maxBuyPrice,
    min_sell_price: usesCurrentPrice ? filters.minSellPrice : null,
    max_sell_price: usesCurrentPrice ? filters.maxSellPrice : null,
    min_buy_orders: filters.minBuyOrders,
    max_buy_orders: filters.maxBuyOrders,
    min_sell_orders: filters.minSellOrders,
    max_sell_orders: filters.maxSellOrders,
    min_steam_sales_14d: null,
    min_daily_sales: filters.minDailySales,
    min_median_daily_sales: usesMedianPrice
      ? filters.minMedianDailySales
      : null,
    min_active_days_pct: filters.minActiveDaysPct,
    max_expected_sale_days: filters.maxExpectedSaleDays,
    min_safe_volume_profit: filters.minSafeVolumeProfit,
    min_median_price: usesMedianPrice ? filters.minMedianPrice : null,
    max_median_price: usesMedianPrice ? filters.maxMedianPrice : null,
    min_average_price: usesAveragePrice ? filters.minAveragePrice : null,
    max_average_price: usesAveragePrice ? filters.maxAveragePrice : null,
    median_window_days: filters.medianWindowDays,
    median_weighted: filters.medianWeighted,
    profitable_spread_pct: filters.profitableSpreadPct,
    profit_sort: filters.profitSort,
    limit: 60,
    offset: 0,
    include_analytics: false,
  };
}

export function applyLocalFilters(
  rows: Opportunity[],
  filters: ComparisonFilters,
  searchQuery = "",
): Opportunity[] {
  const normalizedQuery = searchQuery.trim().toLocaleLowerCase("ru-RU");
  return rows.filter((row) => {
    if (
      normalizedQuery &&
      !row.hash_name.toLocaleLowerCase("ru-RU").includes(normalizedQuery)
    ) {
      return false;
    }
    if (filters.hideNegativeDeals && row.profit_abs < 0) {
      return false;
    }
    if (
      filters.hideStickers &&
      /(?:sticker|sticker slab|graffiti)/i.test(row.hash_name)
    ) {
      return false;
    }
    return true;
  });
}
